import { FunctionComponent, ReactElement } from 'react';
import { EmbedBlock, PortalBlockPropsBase } from './portal-block';
import { PortalStyleConfig } from './portal-theme';
import { ThemeColorSchemas } from './theme-color-schemas';

// тут отношение меняем местами, так как это число будет умножаться на 100 и применяться к блоку как паддинг снизу в %
export enum FRAME_RATIO {
  DEFAULT = 3 / 4,
  WIDE_SCREEN = 9 / 16,
  INSTAGRAM = 229 / 161,
  TIKTOK = 33 / 49,
}

type GetFrameSrcFunction = (src: string) => string;
type GetOriginUrlFunction = (src: string) => string;

export type FrameAttributes = {
  readonly sandbox?: string;
  readonly allow?: string;
};

type FrameOptions = {
  readonly pattern: RegExp;
  readonly frameRatio?: FRAME_RATIO | false;
  getFrameSrc?: GetFrameSrcFunction;
  getOriginUrl?: GetOriginUrlFunction;
  attributes?: FrameAttributes;
};

export type Frames = {
  readonly [serviceId: string]: FrameOptions;
};

type EmbedOptions = {
  readonly pattern: RegExp;
  readonly frameRatio?: FRAME_RATIO | false;
  readonly Component: FunctionComponent<EmbedComponentProps>;
};

export type Embeds = {
  readonly [serviceId: string]: EmbedOptions;
};

export type SkipIframely = {
  readonly [serviceId: string]: { pattern: RegExp };
};

export type EmbedComponentProps = {
  src: string;
  frameOptions?: FrameOptions;
  html?: string;
  type?: string;
  onEmbedLoad?: () => void;
};

export type EmbedProps = {
  Component: FunctionComponent<EmbedComponentProps> | null;
  props: EmbedComponentProps;
  ratio: FRAME_RATIO | false;
};

export type IframelyResponse = {
  html?: string;
};

export interface EmbedBlockProps extends PortalBlockPropsBase {
  block: EmbedBlock;
}

export type EmbedWrapperProps = {
  disableSize: boolean;
  disableFullWidthSize: boolean;
  loading: boolean;
  children: ReactElement | null | false;
  isFullWidth: boolean;
  setFullWidth: (isFullWidth: boolean) => void;
  src: string;
  themeColors: ThemeColorSchemas;
  themeStyle: PortalStyleConfig;
};

export type GistData = {
  stylesheet: string;
  div: string;
};
// facebook sdk types
export type FbAsyncInitCb = () => void;
export type FBSdk = {
  XFBML: {
    parse: (el: ParentNode) => void;
  };
  init: (el: { appId: string; xfbml: boolean; version: string }) => void;
  Event: {
    subscribe: (event: string, cb: () => void) => void;
  };
};
// twitter sdc types
export type TWTTRSdk = {
  ready: (cb: (twttr: TWTTRSdk) => void) => void;
  _e: ((twttr: TWTTRSdk) => void)[];
  events: {
    bind: (event: string, cb: () => void) => void;
  };
  widgets: {
    createTweet: (tweetId: string, el: HTMLDivElement | null, params: Record<string, string>) => void;
  };
};
// typeform sdk types
export type TypeformSdk = {
  makeWidget: (el: HTMLDivElement, src: string) => void;
};

export type JsonpCallbackRegistry = Record<string, (data: GistData) => void>;
